import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { inject } from '@angular/core';

/**
 * Blocks web-only surfaces (Dashboard, Admin, Platform-Admin, Profile,
 * User Guide, Office Queue) when running inside the installed Capacitor app.
 *
 * `Capacitor.isNativePlatform()` is the real signal for "installed app" —
 * unlike `APP_PLATFORM_TYPES.Mobile` in navigation.data.ts, which is a
 * screen-width proxy set by dense.component.ts for responsive layout and
 * also applies to phone browsers. Phone browsers must keep full access;
 * only the installed app is scoped down to the request workflow.
 *
 * On failure: redirects to /requests/my-requests (the app's only surface).
 * No-op in any browser, regardless of screen size.
 *
 * Route wiring:
 *   {
 *     path: 'dashboard',
 *     canActivate: [NativeAppGuard],
 *     loadChildren: () => import('app/modules/dashboard/dashboard.routes'),
 *   }
 */
export const NativeAppGuard: CanActivateFn | CanActivateChildFn = () => {
    if (!Capacitor.isNativePlatform()) {
        return true;
    }

    const router = inject(Router);
    return router.parseUrl('requests/my-requests');
};
